import script from "./GradientTitle.vue?vue&type=script&lang=ts&setup=true"
export * from "./GradientTitle.vue?vue&type=script&lang=ts&setup=true"

import "./GradientTitle.vue?vue&type=style&index=0&id=5c9bf8dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c9bf8dc"]])

export default __exports__